import React from "react";
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import {useAppState} from "@stores/AppStateContext";

import {TaskListDeleteProps} from "../modal-names";

import {DeleteWithConfirmation} from "../components/DeleteWithConfirmation/DeleteWithConfirmation";
import {deleteTaskList} from "../../../../actions/taskList/deleteTaskList";

export const TaskListDelete = observer(({
    taskListModel,
    taskListUnitModel,
}: TaskListDeleteProps) => {
    const appState = useAppState();
    const hasChilds = taskListModel.childIds.length > 0;

    return (
        <DeleteWithConfirmation
            header={intl.get('TaskListDelete.header').d('Delete this task list?')}
            confirmText={intl.get('TaskListDelete.Confirm.button').d('Delete Task List')}
            text={intl.getHTML('TaskListDelete.text', {taskListName: taskListModel.name}).d(`You’re about to permanently delete the task list <strong>{taskListName}</strong>, including all tasks it contains and their data. <strong>This action cannot be undone.</strong>`)}
            onConfirm={async () => {
                const serviceRegistry = appState.getServiceRegistry();
                await deleteTaskList(
                    serviceRegistry.getDataClientService(),
                    serviceRegistry.getAuthService(),
                    taskListModel,
                    taskListUnitModel
                );
                appState.setModal(null);
            }}
            onClose={() => appState.setModal(null)}
            showConfirmation={hasChilds}
            conditions={[
                intl.get('TaskListDelete.first-field.text').d('All completion history and reports will be deleted'),
                intl.get('TaskListDelete.second-field.text').d('Attached photos and other confirmations cannot be recovered'),
            ]}
        />
    );
});
